import { EstimatorMarkerOverlay } from './EstimatorMarkerOverlay';

export class RentEstimatorMarkerOverlay extends EstimatorMarkerOverlay {}
